module.exports = __webpack_public_path__ + "static/media/andreasloizou.8d5b0d98.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/andreasloizou.webp
// module id = 453
// module chunks = 0